import $http from "../axios";

const state = {
  productCombos: []
};

const getters = {
  productCombos: state => state.productCombos
};

const actions = {
  getProductCombos({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`product-combo/list`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PRODUCT_COMBOS", res.data.payload.productCombos);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  createProductCombo({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`product-combo/create`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("CREATE_PRODUCT_COMBO", res.data.payload.productCombo);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateProductCombo({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`product-combo/update`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_PRODUCT_COMBO", res.data.payload.productCombo);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteProductCombo({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`product-combo/delete`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("DELETE_PRODUCT_COMBO", data.comboId);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_PRODUCT_COMBOS(state, productCombos) {
    state.productCombos = productCombos;
  },

  CREATE_PRODUCT_COMBO(state, productCombo) {
    state.productCombos.push(productCombo);
  },

  UPDATE_PRODUCT_COMBO(state, productCombo) {
    const index = state.productCombos.findIndex(
      c => c._id === productCombo._id
    );
    if (index > -1) state.productCombos.splice(index, 1, productCombo);
  },

  DELETE_PRODUCT_COMBO(state, comboId) {
    const index = state.productCombos.findIndex(c => c._id === comboId);
    if (index > -1) state.productCombos.splice(index, 1);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
